import React from 'react';
import UpdateStatusModal from '../UpdateStatusModal';
import ActiveBatchesModal from '../DocumentModals/ActiveBatchesModal';

const ModalsSection = ({
  updateStatusModalOpen,
  setUpdateStatusModalOpen,
  selectedProjectForUpdate,
  setSelectedProjectForUpdate,
  openActiveBatchesModal,
  setOpenActiveBatchesModal,
  cmoSite,
  deliverableType,
  onRefresh,
  setSnackbar,
}) => {
  return (
    <>
      <UpdateStatusModal
        open={updateStatusModalOpen}
        onClose={() => {
          setUpdateStatusModalOpen(false);
          setSelectedProjectForUpdate(null);
        }}
        projectData={selectedProjectForUpdate}
        onRefresh={onRefresh}
        setSnackbar={setSnackbar}
      />
      <ActiveBatchesModal
        open={openActiveBatchesModal}
        onClose={() => setOpenActiveBatchesModal(false)}
        cmoSite={cmoSite}
        deliverableType={deliverableType}
      />
    </>
  );
};

export default ModalsSection;

